import React, { useContext, useState } from 'react'
import { createCustomers } from '../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../Utility/UserContext';

const CustomerAddModal = ({ showCustomer, setShowCustomer, onReqCustomer }) => {
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

    const [formdata, setFormdata] = useState({
        name: "",
        contact_email: "",
        phone: "",
        country: "",
        branch: "",
        additional_details: "",
        customer_type: "",
        TRN_no: "",
        status: "0",
        CR_DR: "0",
        shop_id: shopItem?.shop_id || "0",
    });

    const [errors, setErrors] = useState({});

    const handleChangeCustomer = (e) => {
        const { name, value } = e.target;
        setFormdata({
            ...formdata,
            [name]: value,
        });
        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));
    }

    const handleClearCustomer = () => {
        setFormdata({
            name: "",
            contact_email: "",
            phone: "",
            country: "",
            branch: "",
            additional_details: "",
            customer_type: "",
            TRN_no: "",
            status: "0",
            CR_DR: "0",
            shop_id: shopItem?.shop_id || "0",
        });
        setErrors({});
        setShowCustomer(false);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleAddCustomer = async () => {
        showLoader()
        const validationErrors = {};

        if (!formdata.name?.trim()) {
            validationErrors.name = "Name is required.";
        }

        if (!formdata.phone || formdata.phone.length < 10) {
            validationErrors.phone = !formdata.phone
                ? "Phone number is required."
                : "Phone number must be at least 10 digits.";
        }

        if (!formdata.customer_type) {
            validationErrors.customer_type = "Customer type is required.";
        }

        if (formdata.contact_email?.trim() && !validateEmail(formdata.contact_email)) {
            validationErrors.contact_email = "Invalid email address.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            hideLoader()
            toast.error(validationErrors[Object.keys(validationErrors)[0]]);
            return;
        }

        try {
            await createCustomers(formdata);
            hideLoader()
            toast.success("Customer added successfully");
            handleClearCustomer();
            onReqCustomer();
            setShowCustomer(false);
        } catch (error) {
            console.error("Error adding customer:", error);
            hideLoader();
            toast.error(error.response?.data?.message || "Failed to add customer");
        }
    };

    return (
        <div
            className={`modal fade ${showCustomer ? "show d-block" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showCustomer ? "block" : "none", background: "rgba(0,0,0,0.55)", zIndex: 1070 }}
            aria-hidden={!showCustomer}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content border-0 shadow-lg rounded-3 p-3">
                    <div className="modal-header border-0 pb-0 px-4 pt-3">
                        <h5 className="modal-title fw-bold text-slate-800" style={{ fontSize: "20px" }}>Add Customer</h5>
                        <button type="button" className="btn-close" onClick={handleClearCustomer} aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-start py-3 px-4">
                        <div className="row g-3">
                            {/* Left Column */}
                            <div className="col-md-6">
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Customers *</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formdata.name}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter Name"
                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    />
                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                </div>
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Email</label>
                                    <input
                                        type="email"
                                        name="contact_email"
                                        value={formdata.contact_email}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter Email"
                                        className={`form-control ${errors.contact_email ? 'is-invalid' : ''}`}
                                    />
                                    {errors.contact_email && <div className="invalid-feedback">{errors.contact_email}</div>}
                                </div>
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Phone *</label>
                                    <input
                                        type="number"
                                        name="phone"
                                        value={formdata.phone}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter Phone"
                                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                    />
                                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                </div>
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Country</label>
                                    <input
                                        type="text"
                                        name="country"
                                        value={formdata.country}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter Country"
                                        className="form-control"
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">TRN.no</label>
                                    <input
                                        type="text"
                                        name="TRN_no"
                                        value={formdata.TRN_no}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter TRN"
                                        className="form-control"
                                    />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Branch</label>
                                    <input
                                        type="text"
                                        name="branch"
                                        value={formdata.branch}
                                        onChange={handleChangeCustomer}
                                        placeholder="Enter Branch"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            
                            {/* Right Column */}
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Additional Details</label>
                                    <textarea
                                        name="additional_details"
                                        value={formdata.additional_details}
                                        onChange={handleChangeCustomer}
                                        placeholder="give some additional details"
                                        className="form-control"
                                        rows={6}
                                        style={{ resize: "none" }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label text-sm fw-semibold text-slate-600 mb-1">Customer Type *</label>
                                    <select
                                        name="customer_type"
                                        value={formdata.customer_type}
                                        onChange={handleChangeCustomer}
                                        className={`form-select ${errors.customer_type ? 'is-invalid' : ''}`}
                                    >
                                        <option value="">Customer Type</option>
                                        <option value="agent">Agent</option>
                                        <option value="customer">Customer</option>
                                    </select>
                                    {errors.customer_type && <div className="invalid-feedback">{errors.customer_type}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0 pt-0 px-4 d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-secondary px-4 py-2"
                            onClick={handleClearCustomer}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary px-4 py-2"
                            onClick={handleAddCustomer}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerAddModal;